import { Group, Paper, Stack, Text } from '@mantine/core';
import { Link } from '@tanstack/react-router';

import { PublicationCardIdentifiers } from '@/module/Author/Publication/components/PublicationCardIdentifiers';
import { PublicationTitle } from '@/module/Author/Publication/components/PublicationTitle';

import { BdiList, LanguagePill, NoOfAuthors, PublicationPages, PublishedAtText, WosIndexAt } from '@feature/utils';

import { Proceeding } from './../../model/ProceedingTypes';
import classes from './ProceedingCard.module.css';

export interface ProceedingCardProps {
  proceeding: Proceeding;
  to?: string;
  onClick?: () => void;
}

export function ProceedingCard({ proceeding, to, onClick }: ProceedingCardProps) {
  const {
    publishedAt,
    authors,
    language,
    noOfPages,
    publisher,
    startPage,
    endPage,
    identifiers,
    publisherType,
    bdis,
    wosIndexingYear,
  } = proceeding;

  return (
    <Paper
      className={classes.card}
      component={to ? Link : undefined}
      onClick={onClick}
      to={to}
      p="lg"
      c="var(--mantine-color-text)"
    >
      <Stack gap="xs">
        <PublicationTitle publication={proceeding} />
        <Group>
          {publisher && (
            <>
              <Text>
                {publisher.title} {publisherType?.name ? `(${publisherType.name})` : ''}
              </Text>
              <PublicationPages
                startPage={startPage}
                endPage={endPage}
                noOfPages={noOfPages}
              />
            </>
          )}
        </Group>
        <BdiList bdis={bdis} />
        <Group>
          <PublishedAtText
            date={publishedAt}
            size="sm"
            c="dimmed"
          />
          <WosIndexAt year={wosIndexingYear} />
          <NoOfAuthors authors={authors} />
        </Group>
        <Group>
          <LanguagePill language={language} />
          {identifiers && <PublicationCardIdentifiers identifiers={identifiers} />}
        </Group>
      </Stack>
    </Paper>
  );
}
